import React, { useEffect, useState } from "react";
import PublicLayout from "@/components/PublicLayout";
import StoriesSection from "@/components/StoriesSection";
import { api } from "@/lib/api";

export default function Stories() {
  const [stories, setStories] = useState([]);
  useEffect(() => {
    api.get("/stories").then((r) => setStories(r.data)).catch(() => {});
  }, []);

  return (
    <PublicLayout>
      <section className="pt-32 md:pt-40 pb-8">
        <div className="max-w-[1500px] mx-auto px-5 md:px-10">
          <div className="eyebrow mb-4">The Journal · {stories.length} Stories</div>
          <h1 className="font-display italic text-5xl md:text-8xl leading-[0.95] tracking-tight max-w-3xl">
            Stories from the studio.
          </h1>
        </div>
      </section>
      <StoriesSection stories={stories} />
    </PublicLayout>
  );
}
